(function () {
  function rootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function containsBlockedWords(text) {
    if (!text) return false;

    var blockedWords = [
      'fuck',
      'fucking',
      'fucker',
      'motherfucker',
      'shit',
      'bullshit',
      'cunt',
      'bitch',
      'bastard',
      'wanker',
      'prick',
      'twat',
      'arsehole',
      'asshole',
      'dickhead'
    ];

    var normalised = text
      .toLowerCase()
      .replace(/[@]/g, 'a')
      .replace(/[!1|]/g, 'i')
      .replace(/[$5]/g, 's')
      .replace(/[0]/g, 'o')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    return blockedWords.some(function (word) {
      var pattern = new RegExp('\\b' + word + '\\b', 'i');
      return pattern.test(normalised);
    });
  }

  function setStatus(root, text) {
    var status = qs(root, '[data-gm-status]');

    if (status) {
      status.textContent = text || '';
    }
  }

  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart could not be read.');
      }

      return response.json();
    });
  }

  function getGiftLines(cart) {
    return cart.items
      .map(function (item, index) {
        return {
          item: item,
          line: index + 1
        };
      })
      .filter(function (entry) {
        return entry.item.properties && entry.item.properties['_Gift Card Product'] === 'true';
      });
  }

  function getPayload(root) {
    var selectedVariant = qs(root, '[data-gm-selected-variant-id]');
    var selectedCard = qs(root, '[data-gm-selected-card-title]');
    var selectedHandwritten = qs(root, '[data-gm-selected-handwritten]');
    var recipient = qs(root, '[data-gm-recipient]');
    var occasion = qs(root, '[data-gm-occasion]');
    var message = qs(root, '[data-gm-message]');

    return {
      variantId: selectedVariant ? selectedVariant.value.trim() : '',
      cardTitle: selectedCard ? selectedCard.value.trim() : '',
      handwritten: selectedHandwritten ? selectedHandwritten.value === 'true' : false,
      recipient: recipient ? recipient.value.trim() : '',
      occasion: occasion ? occasion.value.trim() : '',
      message: message ? message.value.trim() : ''
    };
  }

function giftProperties(payload) {
  var properties = {
    '_Gift Card Product': 'true',
    'Message Style': payload.handwritten ? 'Handwritten' : 'Printed'
  };

  if (payload.recipient) {
    properties.Recipient = payload.recipient;
  }

  if (payload.occasion) {
    properties.Occasion = payload.occasion;
  }

  if (payload.message) {
    properties['Gift Message'] = payload.message;
  }

  return properties;
}
  function addGiftProduct(payload) {
    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(payload.variantId),
        quantity: 1,
        properties: giftProperties(payload)
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Gift message could not be added.');
      }

      return response.json();
    });
  }

  function changeCartLine(lineKey, quantity, payload) {
    var body = {
      id: lineKey,
      quantity: quantity
    };

    if (payload) {
      body.properties = giftProperties(payload);
    }

    return fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Gift message could not be updated.');
      }

      return response.json();
    });
  }

  function removeGiftLines(giftLines) {
    return giftLines.reduce(function (promise, entry) {
      return promise.then(function () {
        return changeCartLine(entry.item.key, 0);
      });
    }, Promise.resolve());
  }

  function saveGiftProduct(payload) {
    return fetchCart().then(function (cart) {
      var giftLines = getGiftLines(cart);

      if (giftLines.length === 0) {
        return addGiftProduct(payload);
      }

      if (giftLines.length === 1) {
        var existing = giftLines[0];

        if (String(existing.item.variant_id) === String(payload.variantId)) {
          return changeCartLine(existing.item.key, 1, payload);
        }

        return changeCartLine(existing.item.key, 0).then(function () {
          return addGiftProduct(payload);
        });
      }

      return removeGiftLines(giftLines).then(function () {
        return addGiftProduct(payload);
      });
    });
  }

  function removeGiftProduct() {
    return fetchCart().then(function (cart) {
      var giftLines = getGiftLines(cart);
      return removeGiftLines(giftLines);
    });
  }

  function findSelectedOption(root) {
    var currentVariantInput = qs(root, '[data-gm-selected-variant-id]');
    var currentVariantId = currentVariantInput ? currentVariantInput.value : '';

    if (currentVariantId) {
      var optionById = qs(root, '[data-gm-card-option][data-gm-variant-id="' + currentVariantId + '"]');

      if (optionById) {
        return optionById;
      }
    }

    return qs(root, '[data-gm-card-option][aria-checked="true"]');
  }

  function updateMessageText(root) {
    var messageInput = qs(root, '[data-gm-message]');
    var previewText = qs(root, '[data-gm-message-preview-text]');

    if (!messageInput || !previewText) return;

    var value = messageInput.value.trim();

    if (value) {
      previewText.textContent = value;
      previewText.classList.remove('is-empty');
    } else {
      previewText.textContent = 'Your message will appear here as you write.';
      previewText.classList.add('is-empty');
    }
  }

  function updateMessageStyle(root) {
    var selectedHandwritten = qs(root, '[data-gm-selected-handwritten]');
    var previewText = qs(root, '[data-gm-message-preview-text]');

    if (!previewText) return;

    if (selectedHandwritten && selectedHandwritten.value === 'true') {
      previewText.classList.add('is-handwritten');
    } else {
      previewText.classList.remove('is-handwritten');
    }
  }

  function updateBackImage(root, option) {
    if (!option) return;

    var preview = qs(root, '[data-gm-message-preview]');
    var previewInner = qs(root, '.gm-card-message-preview__inner');
    var previewImage = qs(root, '[data-gm-message-preview-image]');
    var fallbackHeader = qs(root, '[data-gm-message-preview-fallback-header]');
    var fallbackAddress = qs(root, '[data-gm-message-preview-fallback-address]');

    if (!preview || !previewInner || !previewImage) return;

    var backImage = option.getAttribute('data-gm-back-image');
    var backImageWidth = option.getAttribute('data-gm-back-image-width') || '1200';
    var backImageHeight = option.getAttribute('data-gm-back-image-height') || '900';
    var backAspect = option.getAttribute('data-gm-back-aspect') || (backImageWidth + ' / ' + backImageHeight);

    previewInner.style.setProperty('--gm-card-back-aspect', backAspect);

    if (backImage) {
      preview.classList.add('gm-card-message-preview--has-image');
      previewInner.classList.add('gm-card-message-preview__inner--image');

      previewImage.hidden = false;
      previewImage.src = backImage;
      previewImage.width = backImageWidth;
      previewImage.height = backImageHeight;

      if (fallbackHeader) {
        fallbackHeader.hidden = true;
      }

      if (fallbackAddress) {
        fallbackAddress.hidden = true;
      }
    } else {
      preview.classList.remove('gm-card-message-preview--has-image');
      previewInner.classList.remove('gm-card-message-preview__inner--image');

      previewImage.hidden = true;
      previewImage.removeAttribute('src');

      if (fallbackHeader) {
        fallbackHeader.hidden = false;
      }

      if (fallbackAddress) {
        fallbackAddress.hidden = false;
      }
    }
  }

  function updatePreview(root, option) {
    updateMessageText(root);
    updateMessageStyle(root);
    updateBackImage(root, option || findSelectedOption(root));
  }

  function chooseCard(root, card) {
    if (!card || card.getAttribute('aria-disabled') === 'true') return;

    qsa(root, '[data-gm-card-option]').forEach(function (other) {
      other.setAttribute('aria-checked', 'false');
    });

    card.setAttribute('aria-checked', 'true');

    var selectedVariant = qs(root, '[data-gm-selected-variant-id]');
    var selectedCard = qs(root, '[data-gm-selected-card-title]');
    var selectedHandwritten = qs(root, '[data-gm-selected-handwritten]');
    var previewImage = qs(root, '[data-gm-card-preview-image]');
    var previewUrl = card.getAttribute('data-gm-preview-image');
    var title = card.getAttribute('data-gm-card-title') || '';
    var handwritten = card.getAttribute('data-gm-handwritten') === 'true';

    if (selectedVariant) {
      selectedVariant.value = card.getAttribute('data-gm-variant-id') || '';
    }

    if (selectedCard) {
      selectedCard.value = title;
    }

    if (selectedHandwritten) {
      selectedHandwritten.value = handwritten ? 'true' : 'false';
    }

    if (previewImage && previewUrl) {
      previewImage.src = previewUrl;
      previewImage.alt = title || 'Selected card preview';
    }

    updatePreview(root, card);
  }

  function initPage(root) {
    if (root.__gmInit) return;
    root.__gmInit = true;

    var message = qs(root, '[data-gm-message]');
    var count = qs(root, '[data-gm-count]');

    if (message && count) {
      count.textContent = String(message.value.length);

      message.addEventListener('input', function () {
        count.textContent = String(message.value.length);
      });
    }

    if (message) {
      message.addEventListener('input', function () {
        updateMessageText(root);
      });
    }

    qsa(root, '[data-gm-card-option]').forEach(function (card) {
      card.addEventListener('click', function () {
        chooseCard(root, card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseCard(root, card);
        }
      });
    });

    updatePreview(root);

var save = qs(root, '[data-gm-save]');
var cardOnly = qs(root, '[data-gm-card-only]');

function updateCardOnlyButtonState() {
  if (!cardOnly) return;

  var payload = getPayload(root);
  var hasMessage = Boolean(payload.message);

  cardOnly.disabled = hasMessage;

  if (hasMessage) {
    cardOnly.setAttribute('aria-disabled', 'true');
    cardOnly.setAttribute('title', 'Clear the message to include the card without a message.');
  } else {
    cardOnly.removeAttribute('aria-disabled');
    cardOnly.removeAttribute('title');
  }
}

function handleSave(button, cardOnlyMode) {
  var payload = getPayload(root);

  if (!payload.variantId) {
    setStatus(root, 'Please choose a card.');
    return;
  }

  if (cardOnlyMode && payload.message) {
    setStatus(root, 'Clear the message first, or use Add message.');
    updateCardOnlyButtonState();
    return;
  }

  if (cardOnlyMode) {
    payload.message = '';
    payload.recipient = '';
    payload.occasion = '';
  }

  if (!cardOnlyMode && !payload.message) {
    setStatus(root, 'Please add a message, or choose Include card only.');
    return;
  }

  if (payload.message && containsBlockedWords(payload.message)) {
    setStatus(root, 'Please amend your message before saving. We are unable to include offensive language.');
    return;
  }

  button.disabled = true;

  if (cardOnlyMode) {
    setStatus(root, 'Adding card...');
  } else {
    setStatus(root, 'Saving gift message...');
  }

  saveGiftProduct(payload)
    .then(function () {
      if (cardOnlyMode) {
        setStatus(root, 'Card added.');
      } else {
        setStatus(root, 'Gift message saved.');
      }

      var returnUrl = root.getAttribute('data-gm-return-url') || rootUrl() + 'cart';
      window.location.href = returnUrl;
    })
    .catch(function (error) {
      setStatus(root, error.message || 'Card could not be added.');
    })
    .finally(function () {
      button.disabled = false;
      updateCardOnlyButtonState();
    });
}

if (save) {
  save.addEventListener('click', function () {
    handleSave(save, false);
  });
}

if (cardOnly) {
  cardOnly.addEventListener('click', function () {
    handleSave(cardOnly, true);
  });
}

if (message && cardOnly) {
  message.addEventListener('input', updateCardOnlyButtonState);
}

updateCardOnlyButtonState();


    var remove = qs(root, '[data-gm-remove]');

    if (remove) {
      remove.addEventListener('click', function () {
        remove.disabled = true;
        setStatus(root, 'Removing gift message...');

        removeGiftProduct()
          .then(function () {
            var returnUrl = root.getAttribute('data-gm-return-url') || rootUrl() + 'cart';
            window.location.href = returnUrl;
          })
          .catch(function (error) {
            setStatus(root, error.message || 'Gift message could not be removed.');
          })
          .finally(function () {
            remove.disabled = false;
          });
      });
    }
  }

  function removeOrphanGiftCards() {
    return fetchCart()
      .then(function (cart) {
        var giftLines = getGiftLines(cart);

        var realLines = cart.items.filter(function (item) {
          return !(item.properties && item.properties['_Gift Card Product'] === 'true');
        });

        if (giftLines.length > 0 && realLines.length === 0) {
          return removeGiftLines(giftLines).then(function () {
            window.location.reload();
          });
        }
      })
      .catch(function () {
        // Silent guard. This should never block normal cart behaviour.
      });
  }

  function initCartGuard() {
    if (window.__giftMessageCartGuardInit) return;
    window.__giftMessageCartGuardInit = true;

    removeOrphanGiftCards();

    document.addEventListener('click', function (event) {
      var removeTrigger = event.target.closest(
        '.remove-from-cart-link, .remove, [href*="/cart/change"], [href*="/cart/update"], [data-key][data-line]'
      );

      if (!removeTrigger) return;

      window.setTimeout(removeOrphanGiftCards, 500);
      window.setTimeout(removeOrphanGiftCards, 1200);
      window.setTimeout(removeOrphanGiftCards, 2200);
    });

    document.addEventListener('cart:updated', removeOrphanGiftCards);
    document.addEventListener('cart:change', removeOrphanGiftCards);
    document.addEventListener('cart:refresh', removeOrphanGiftCards);
  }

  function init() {
    qsa(document, '[data-gm-card-page]').forEach(initPage);
    initCartGuard();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  window.GiftMessageModule = {
    init: init
  };
})();